<div class="dashboard-wrapper" dir="rtl">
    <div class="grid-container">

        <!-- راهنمای رنگ‌ها -->
        <div class="legend-container w-full d-flex justify-content-center flex-wrap gap-3 my-2">
            <div class="legend-item d-flex items-center gap-2"><span class="legend-dot dot-green"></span> عملکرد عادی</div>
            <div class="legend-item d-flex items-center gap-2"><span class="legend-dot dot-yellow"></span> نیاز به توجه</div>
            <div class="legend-item d-flex items-center gap-2"><span class="legend-dot dot-orange"></span> هشدار</div>
            <div class="legend-item d-flex items-center gap-2"><span class="legend-dot dot-red"></span> بحرانی</div>
        </div>

        <!-- 1. درصد بار ژنراتور -->
        <div class="chart-card">
            <div class="chart-title">درصد بار ژنراتور (تی‌آی لود)</div>
            <div class="chart-box"><canvas id="chartLoad"></canvas></div>
        </div>

        <!-- 2. توان اکتیو سه فاز -->
        <div class="chart-card">
            <div class="chart-title">توان اکتیو فازها (kW)</div>
            <div class="chart-box"><canvas id="chartActivePower"></canvas></div>
        </div>

        <!-- 3. جریان سه فاز -->
        <div class="chart-card">
            <div class="chart-title">جریان سه فاز (A)</div>
            <div class="chart-box"><canvas id="chartCurrent"></canvas></div>
        </div>

        <!-- 4. ولتاژ سه فاز -->
        <div class="chart-card">
            <div class="chart-title">ولتاژ سه فاز (V)</div>
            <div class="chart-box"><canvas id="chartVoltage"></canvas></div>
        </div>

        <!-- 5. فرکانس -->
        <div class="chart-card">
            <div class="chart-title">فرکانس (Hz)</div>
            <div class="chart-box"><canvas id="chartFrequency"></canvas></div>
        </div>

        <!-- 6. ضریب توان -->
        <div class="chart-card">
            <div class="chart-title">ضریب توان (PF)</div>
            <div class="chart-box"><canvas id="chartPF"></canvas></div>
        </div>

        <!-- 7. انرژی تولیدی (روزانه) -->
        <div class="chart-card span-2">
            <div class="chart-title">انرژی تولیدی (kWh)</div>
            <div class="chart-box"><canvas id="chartEnergy"></canvas></div>
        </div>

        <!-- 8. عدم تعادل ها -->
        <div class="chart-card">
            <div class="chart-title">عدم تعادل (جریان، ولتاژ، توان)</div>
            <div class="chart-box"><canvas id="chartUnbalance"></canvas></div>
        </div>

        <!-- 9. راندمان و سلامت -->
        <div class="chart-card">
            <div class="chart-title">راندمان و سلامت (Efficiency / Health)</div>
            <div class="chart-box"><canvas id="chartHealthEff"></canvas></div>
        </div>

        <!-- 10. دماهای سیستم -->
        <div class="chart-card">
            <div class="chart-title">دمای مایع خنک‌کننده و روغن</div>
            <div class="chart-box"><canvas id="chartTemp"></canvas></div>
        </div>

    </div>
</div>
